<template>
  <div>
    <h1>{{ $t("report.onlineuser.onlineuser") }}</h1>
    <div class="d-flex">
      <h4 class="unmargin head-dropdown">Product</h4>
      <mdb-dropdown>
        <mdb-dropdown-toggle slot="toggle">
          {{ partnerSelected === "DS" ? "ASKMEBET" : partnerSelected }}
        </mdb-dropdown-toggle>
        <mdb-dropdown-menu>
          <mdb-dropdown-item
            v-for="(item, i) in productList"
            :key="i"
            @click="seletPartner(item)"
          >
            {{ item === "DS" ? "ASKMEBET" : item }}
          </mdb-dropdown-item>
        </mdb-dropdown-menu>
      </mdb-dropdown>
    </div>
    <div class="section-group mt-3 col-sm-9 col-md-7 col-xl-5">
      <Table :head="TableHead">
        <template v-slot:body>
          <UserOnlineSocketBody
            :data="playerOnlineList"
            :footSum="footSum"
          />
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import Table from '@/components/Table/Index.vue';
import UserOnlineSocketBody from '@/components/Table/UserOnlineSocketBody.vue';
import UserOnlineData from '@/data/UserOnlineData';
import { getModule } from 'vuex-module-decorators';
import GeneralModule from '@/store/modules/General';
import utils from '@/services/utils';
import { SOCKET_URL } from '@/utils/api';
import { io } from 'socket.io-client';

export default {
  components: {
    Table,
    UserOnlineSocketBody,
  },
  data() {
    return {
      TableHead: {},
      playerOnlineList: [],
      productList: [],
      partnerSelected: 'ALL',
      parent: utils.getUserPersistent().user._id,
      token: utils.getUserPersistent().token,
      role: utils.getUserPersistent().user.role,
      GeneralInstance: {},
      footSum: 0,
    };
  },
  created() {
    this.TableHead = UserOnlineData.TableHead;
    this.GeneralInstance = getModule(GeneralModule, this.$store);
  },
  async mounted() {
    this.GeneralInstance.toggleLoading(true);
    this.ioConnect = await io(SOCKET_URL, {
      auth: { token: `Bearer ${this.token}` },
      transports: ['websocket'],
    });
    this.ioConnect.on('connect_error', (error) => {
      if (error.data.type === 'UnauthorizedError') {
        console.log('User token has expired');
      }
    });
    if (this.role === 'AGENT') {
      this.getAgentUser();
    } else {
      this.ioConnect.on('updateOnlineUsers', async (res) => {
        if (res.data) {
          this.getUserOnline(res.data);
          this.sortProvider(res.data);
          this.GeneralInstance.toggleLoading(false);
        }
      });
    }
  },
  methods: {
    getUserOnline(data) {
      const user = Object.values(data);
      this.footSum = 0;
      if (this.partnerSelected === 'ALL') {
        this.playerOnlineList = user.filter((v) => v.amount !== 0)
          .sort((a, b) => b.amount - a.amount);
        this.footSumery(this.playerOnlineList);
      } else {
        this.playerOnlineList = user.filter((v) => v.amount !== 0)
          .sort((a, b) => b.amount - a.amount);
        this.seletPartner(this.partnerSelected);
        this.footSumery(this.playerOnlineList);
      }
      this.handleUserByDownline(this.playerOnlineList);
      this.GeneralInstance.toggleLoading(false);
    },
    getAgentUser() {
      this.ioConnect.emit('getOnlineUsers', {}, (res) => {
        if (res.data) {
          this.getUserOnline(res.data);
          this.sortProvider(res.data);
        }
      });
      this.GeneralInstance.toggleLoading(false);
      setTimeout(() => {
        this.getAgentUser();
      }, 5000);
    },
    sortProvider(data) {
      if (!this.productList.length) {
        const user = Object.values(data);
        const provider = user.map((v) => v.partner)
          .map((n) => (n === 'DRG' ? 'ASKMEBET' : n));
        this.productList = [...new Set(provider)];
        this.productList.push('ALL');
        this.productList.sort();
        this.productList = this.productList.filter((v) => v !== '');
      }
    },
    handleUserByDownline(data) {
      if (this.role === 'AGENT') {
        this.playerOnlineList = data.map((val) => ({
          amount: val.parentId.filter((id) => id === this.parent).length,
          name: val.name,
          partner: val.partner,
        })).filter((user) => user.amount);
        this.footSum = 0;
        this.footSumery(this.playerOnlineList);
      }
    },
    seletPartner(item) {
      this.partnerSelected = item;
      const provider = item === ' ASKMEBET' ? 'DRG' : item;
      if (item !== 'ALL') {
        this.playerOnlineList = this.playerOnlineList.filter((v) => v.partner === provider);
      }
    },
    footSumery(item) {
      // eslint-disable-next-line no-return-assign
      item.forEach((data) => this.footSum += data.amount);
    },
  },
};
</script>

<style lang="scss" scoped>
box-scroll {
  overflow-y: scroll;
  max-height: 200px;
}

.dropdown {
  border-radius: 5px;
  border: 1px solid #ccc;
}

.unmargin {
  margin: 0px 0px;
}

.head-dropdown {
  align-self: center !important;
  margin-right: 1rem;
}
</style>
